<template>
  <v-dialog
    v-model="dialog"
    :disabled="!hasClient"
    persistent
    max-height="680"
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
    style="z-index: 1100 !important;"
  >
    <template v-slot:activator="{ props }">
      <div v-bind="props" data-cy="apiClients-deleteClient-activator">
        <slot></slot>
      </div>
    </template>

    <div class="vb-dialog vb-dialog-danger">
      <v-card v-cloak data-cy="dialog-deleteClient-modal">
        <v-card-title class="d-flex justify-space-between mb-2">
          {{ $t('routes.apiClients.deleteClient') }}

          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="text-body-1">
        <p class="mb-4">
            {{ $t('routes.apiClients.confirmDeleteClient') }}
          </p>
          <v-alert type="warning" variant="tonal" class="mb-4">
            <strong>{{ client.name }}</strong>
            <br />
            <span>{{ $t('routes.apiClients.clientId') }}: {{ client.client_id }}</span>
          </v-alert>
          <p class="text-grey">
            {{ $t('routes.apiClients.deleteWarning') }}
          </p>
        </v-card-text>

        <v-card-actions>
          <v-btn
            class="ml-auto bg-red-darken-3"
            color="btnOk"
            elevation="0"
            @click="deleteClient"
            :loading="isDeleting"
            data-cy="dialog-deleteClient-ok"
          >
            {{ $t('common.delete') }}
          </v-btn>
          <v-btn
            variant="text"
            @click="dialog = false"
            class="btnCancel"
            data-cy="dialog-deleteClient-cancel"
          >
            {{ $t('common.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';

export default {
  mixins: [DialogActionKeys],
  name: "DeleteClientDialog",
  emits: ['clientDeleted'],
  props: {
    client: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      isDeleting: false,
    };
  },
  methods: {
    deleteClient() {
      this.isDeleting = true;
      this.$emit('clientDeleted');
      this.dialog = false;
      this.isDeleting = false;
    },
  },
  computed: {
    hasClient() {
      return !!(this.client && this.client.client_id);
    },
  },
}
</script>

<style scoped>

</style>
